import svelteRetag from 'svelte-retag';

import { getCssPath } from '$entrypoints/common';
import InteractiveImage from '$apps/InteractiveImage.svelte';

let styleHref = getCssPath();

svelteRetag({
    component: InteractiveImage,
    tagname: 'interactive-image',
    attributes: true,
    shadow: true,
    href: styleHref
});
